/* src/app/builder-screen-beta/sticky-action-bar/sticky-action-bar.component.scss */
.sticky-action-bar {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.95);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid transparent;
  padding: 12px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  min-height: 60px;
}
.sticky-action-bar.elevated {
  background: rgba(255, 255, 255, 0.98);
  border-bottom-color: #e8e8e8;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.sticky-action-bar[data-screen-size=tablet] {
  padding: 10px 20px;
  min-height: 56px;
}
.sticky-action-bar[data-screen-size=mobile] {
  display: none;
}
.action-group {
  display: flex;
  align-items: center;
  gap: 12px;
}
.action-group.templates {
  gap: 8px;
}
.action-group.templates .action-text {
  margin-left: 4px;
  font-size: 13px;
}
.action-group.primary .action-text {
  margin-left: 6px;
  font-weight: 500;
}
.action-group.primary .unsaved-indicator {
  margin-left: 8px;
}
.action-group.primary .unsaved-indicator .indicator-text {
  margin-left: 4px;
  font-size: 12px;
}
.action-group.secondary {
  gap: 8px;
}
.action-group.secondary :host ::ng-deep .ant-btn-group .ant-btn.active {
  background: #e6f7ff;
  border-color: #91d5ff;
  color: #1890ff;
}
.zoom-controls {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 8px;
}
.zoom-controls .zoom-indicator {
  font-size: 12px;
  font-weight: 500;
  color: #595959;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 4px;
  transition: all 0.2s ease;
  min-width: 40px;
  text-align: center;
}
.zoom-controls .zoom-indicator:hover {
  background: #f5f5f5;
  color: #1890ff;
}
.mobile-action-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: white;
  border-top: 1px solid #e8e8e8;
  padding: 16px;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
}
.mobile-action-bar .mobile-primary-actions {
  margin-bottom: 12px;
}
.mobile-action-bar .mobile-secondary-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.mobile-action-bar .mobile-secondary-actions :host ::ng-deep .ant-btn.active {
  background: #e6f7ff;
  border-color: #91d5ff;
  color: #1890ff;
}
:host ::ng-deep .ant-btn {
  display: flex;
  align-items: center;
  border-radius: 6px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
:host ::ng-deep .ant-btn:hover {
  transform: translateY(-1px);
}
:host ::ng-deep .ant-btn:active {
  transform: translateY(0);
}
:host ::ng-deep .ant-btn.ant-btn-primary {
  background:
    linear-gradient(
      135deg,
      #1890ff 0%,
      #096dd9 100%);
  border: none;
  box-shadow: 0 2px 4px rgba(24, 144, 255, 0.2);
}
:host ::ng-deep .ant-btn.ant-btn-primary:hover {
  background:
    linear-gradient(
      135deg,
      #40a9ff 0%,
      #1890ff 100%);
  box-shadow: 0 4px 8px rgba(24, 144, 255, 0.3);
}
:host ::ng-deep .ant-btn.ant-btn-primary:focus {
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}
:host ::ng-deep .ant-btn.ant-btn-text:hover {
  background: rgba(0, 0, 0, 0.04);
}
:host ::ng-deep .ant-btn.ant-btn-text.active {
  background: #e6f7ff;
  color: #1890ff;
}
:host ::ng-deep .ant-divider-vertical {
  height: 20px;
  margin: 0 4px;
  border-color: #e8e8e8;
}
:host ::ng-deep .ant-dropdown-menu {
  border-radius: 8px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  border: 1px solid #e8e8e8;
}
:host ::ng-deep .ant-dropdown-menu .ant-dropdown-menu-item {
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}
:host ::ng-deep .ant-dropdown-menu .ant-dropdown-menu-item:hover {
  background: #f5f5f5;
}
:host ::ng-deep .ant-dropdown-menu .ant-dropdown-menu-item.disabled {
  color: #bfbfbf;
  cursor: not-allowed;
}
:host ::ng-deep .ant-dropdown-menu .ant-dropdown-menu-item.disabled:hover {
  background: transparent;
}
:host ::ng-deep .inspector-mode-dropdown {
  padding: 8px;
  min-width: 280px;
}
:host ::ng-deep .inspector-mode-dropdown app-inspector-mode-toggle {
  display: block;
}
:host ::ng-deep .ant-tag {
  border-radius: 12px;
  display: flex;
  align-items: center;
  font-size: 11px;
  padding: 2px 8px;
}
@media (max-width: 1199px) and (min-width: 768px) {
  .sticky-action-bar {
    padding: 10px 16px;
  }
  .sticky-action-bar .action-group {
    gap: 8px;
  }
  .sticky-action-bar .action-group.templates {
    gap: 6px;
  }
  .sticky-action-bar .action-group.secondary {
    gap: 6px;
  }
  .sticky-action-bar .action-text {
    display: none;
  }
  .zoom-controls {
    padding: 0 4px;
    gap: 4px;
  }
}
@media (max-width: 767px) {
  .sticky-action-bar {
    display: none !important;
  }
  .mobile-action-bar {
    display: block;
  }
}
.sticky-action-bar {
  animation: slideDown 0.3s ease-out;
}
@keyframes slideDown {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
@media (prefers-contrast: high) {
  .sticky-action-bar {
    background: white;
    border-bottom: 2px solid #000;
  }
  .sticky-action-bar.elevated {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  }
}
@media (prefers-reduced-motion: reduce) {
  .sticky-action-bar,
  :host ::ng-deep .ant-btn {
    transition: none;
    animation: none;
  }
  :host ::ng-deep .ant-btn:hover {
    transform: none;
  }
}
/*# sourceMappingURL=sticky-action-bar.component.css.map */
